import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface AnalyticsTooltipCalculationContentProps {
  content: ReactNode;
  img?: string;
}

/*
 * Style.
 */

const StyledCalculationWrapperDiv = styled.div`
  margin-top: 16px;
  // Negative margin to counteract the padding of the parent. Box is 8x wider.
  margin-left: -4px;
  margin-right: -4px;
  padding: 8px 12px 10px 12px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.alphas.white20};
  color: ${(p) => p.theme.greys.white};
  a {
    color: ${(p) => p.theme.greys.white};
    text-decoration: underline;
  }
`;

const StyledTitleDiv = styled.div`
  margin-bottom: 8px;
  font-weight: ${fontWeights.bold};
`;

const StyledImg = styled.img`
  width: 100%;
  margin-top: 12px;
`;

/*
 * Component.
 */

export const AnalyticsTooltipCalculationContent: FC<AnalyticsTooltipCalculationContentProps> = ({
  content,
  img,
}) => (
  <StyledCalculationWrapperDiv>
    <StyledTitleDiv>
      <Trans id="analytics-metric-tooltip-calculation">How is it calculated?</Trans>
    </StyledTitleDiv>
    {content}
    {img && <StyledImg src={img} alt="" />}
  </StyledCalculationWrapperDiv>
);
